<form [formGroup]="formGroup" (ngSubmit)="submit()">
    <div id="wcv-bg">
        <div class="page-content">
            <h2 class="content-title">Pour toute demande d'information</h2>

            <div class="content-text">
                Un de nos conseillers vous contacte gratuitement dans les 48 heures.
                Il suffit de saisir votre numéro ci-dessous :
            </div>
            <div class="phone-line">
                <span style="font-weight: bold;">Votre numéro :</span>
                <div>
                    <input #input1 numberOnly type="text" formControlName="numTel1" minlength="2" maxlength="2" [appAutoTab]="input2" />
                    <input #input2 numberOnly type="text" formControlName="numTel2" minlength="2" maxlength="2" [appAutoTab]="input3" />
                    <input #input3 numberOnly type="text" formControlName="numTel3" minlength="2" maxlength="2" [appAutoTab]="input4" />
                    <input #input4 numberOnly type="text" formControlName="numTel4" minlength="2" maxlength="2" [appAutoTab]="input5" />
                    <input #input5 numberOnly type="text" formControlName="numTel5" minlength="2" maxlength="2" />
                </div>
            </div>

            <div style="text-align: center;">
                <button [disabled]="this.formGroup.invalid" class="submit-button" type="submit">Demander un rappel</button>
            </div>
        </div>
    </div>
</form>